<template>
  <div>
    <h2>这是<em>用户管理</em>画面！</h2>
    <div class="agreement_picture">
      <div class="pdfStyle">
        <!--使用iframe方法 -->
        <iframe :src="src" frameborder="0" style="width: 100%; height: 100%"></iframe>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        //pdf地址,这里我用的是我本地的文件,你也可以使用后台的文件
        // src: '/static/file/8D Soft 软件反馈.pdf', 
        //src: 'http://10.10.5.97/pdf/itext7_pdfHTML.pdf', 
        src:'http://127.0.0.1:8080/download/html2pdf.pdf'
      }
    },
    methods: {
    },
    mounted() {
    }

  }
</script>

<style>
.pdfStyle{
  margin:0 auto;
  width:1400px;
  height: 900px;
}
</style>


// WEBPACK FOOTER //
// src/views/Sys/User.vue